import React, { forwardRef, useMemo, useCallback } from "react";
import { Graphics } from "@pixi/react";
import { Settings } from "../../../settings";

const ReelSetMask = forwardRef(
  ({ symbolWidth, symbolHeight, dividerDimensions }, ref) => {
    // Memoize mask dimensions calculations
    const maskDimensions = useMemo(() => {
      const reelGridWidth =
        symbolWidth * Settings.REEL_COUNT +
        dividerDimensions.width * (Settings.REEL_COUNT - 1);

      return {
        reelGridWidth,
        x: -reelGridWidth / 2,
        y: -(symbolHeight * Settings.SYMBOLS_VISIBLE) / 2,
        width: reelGridWidth,
        height: symbolHeight * Settings.SYMBOLS_VISIBLE,
      };
    }, [symbolWidth, symbolHeight, dividerDimensions.width]);

    // Memoize draw function to prevent recreation on every render
    const draw = useCallback(
      (g) => {
        g.clear();
        g.beginFill(0x000000, 1);
        g.drawRect(
          maskDimensions.x,
          maskDimensions.y,
          maskDimensions.width,
          maskDimensions.height
        );
        g.endFill();
      },
      [maskDimensions]
    );

    return (
      <Graphics
        ref={ref}
        name="overflow_mask"
        draw={draw}
      />
    );
  }
);

export default ReelSetMask;
